document.addEventListener("click", function (e) {

    const toggle = e.target.closest(".bulk-toggle");

    if (toggle) {

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        const dropdown = toggle.closest(".bulk-dropdown");
        const content = dropdown.querySelector(".bulk-content");

        if (dropdown.classList.contains("active")) {

            dropdown.classList.remove("active");
            content.style.display = "none";

        } else {

            document.querySelectorAll(".bulk-dropdown.active").forEach(function(d){

                d.classList.remove("active");

                const c = d.querySelector(".bulk-content");

                if(c){
                    c.style.display = "none";
                }

            });

            dropdown.classList.add("active");
            content.style.display = "block";

        }

        return false;
    }

    document.querySelectorAll(".bulk-dropdown.active").forEach(function(dropdown){

        if(!dropdown.contains(e.target)){

            dropdown.classList.remove("active");

            const content = dropdown.querySelector(".bulk-content");

            if(content){
                content.style.display = "none";
            }

        }

    });

}, true);

window.buildQuickviewBulkDropdown = function (product) {

    const modal = document.querySelector("#jsQuickview");
    const viewDetails = modal.querySelector(".qv-view-details");

    const wrapper = modal.querySelector(".bulk-dropdown");
    const content = modal.querySelector(".qv-bulk-options");
    const selected = modal.querySelector(".qv-bulk-selected");
    const variantInput = modal.querySelector(".qv-variant-id");
    const quantityInput = modal.querySelector(".qv-quantity");
    const price = modal.querySelector(".qv-price");
    const unit = modal.querySelector(".qv-unit");
    const cartUI = modal.querySelector(".collection-cart-ui");

    if (
        !wrapper ||
        !content ||
        !selected ||
        !variantInput ||
        !price ||
        !unit
    ) {
        console.log("Quickview elements missing");
        return;
    }

    const unitLabel =
        window.qvUnit ||
        cartUI.dataset.unit ||
        "Qty";

    content.innerHTML = "";

    product.variants.forEach(function (variant, index) {

        content.insertAdjacentHTML(
            "beforeend",
            `
            <label class="bulk-option">

                <input
                    type="radio"
                    class="variant-radio"
                    name="qv-variant"
                    value="${variant.id}"
                    data-title="${variant.title}"
                    data-price="${'Rs. ' + (variant.price / 100).toLocaleString('en-IN')}"
                    data-price-raw="${variant.price}"
                    ${index === 0 ? "checked" : ""}>

                Buy ${variant.title} ${unitLabel} at ${'Rs. ' + (variant.price / 100).toLocaleString('en-IN')} /${unitLabel}

            </label>
            `
        );

    });

    wrapper.style.display = "";

    const first = content.querySelector(".variant-radio");

    if (first) {

        selected.innerHTML =
            `Buy ${first.dataset.title} ${unitLabel} at ${first.dataset.price} /${unitLabel}`;

        variantInput.value = first.value;

        quantityInput.value = parseInt(first.dataset.title, 10);

        console.log("Initial Variant", first.value);

        console.log("Initial Qty", quantityInput.value);

        price.textContent = first.dataset.price;
            unit.textContent = " / " + unitLabel;

            const totalEl = modal.querySelector(".qv-total");

            if (totalEl) {
                totalEl.textContent =
                    "Rs. " +
                    (
                        Number(first.dataset.priceRaw) / 100 *
                        parseInt(first.dataset.title, 10)
                    ).toLocaleString("en-IN");
            }

    }

    if (viewDetails) {
        viewDetails.href = window.qvProductUrl;
    }

};

document.addEventListener("change", function (e) {

    if (!e.target.classList.contains("variant-radio")) return;

    const radio = e.target;

    const modal = document.querySelector("#jsQuickview");
    if (!modal) return;

    const dropdown = radio.closest(".bulk-dropdown");

    const unitLabel =
        window.qvUnit ||
        modal.querySelector(".collection-cart-ui")?.dataset.unit ||
        "Qty";

    const qty = parseInt(radio.dataset.title, 10);

    // Update selected text
    const selectedEl = modal.querySelector(".qv-bulk-selected");
    if (selectedEl) {
        selectedEl.innerHTML =
            `Buy ${qty} ${unitLabel} at ${radio.dataset.price} /${unitLabel}`;
    }

    // Update price
    const priceEl = modal.querySelector(".qv-price");
    const unitEl = modal.querySelector(".qv-unit");
    const totalEl = modal.querySelector(".qv-total");

    if (priceEl) {
        priceEl.textContent = radio.dataset.price;
    }

    if (unitEl) {
        unitEl.textContent = " / " + unitLabel;
    }

    if (totalEl) {
        totalEl.textContent =
            "Rs. " +
            (Number(radio.dataset.priceRaw) / 100 * qty).toLocaleString("en-IN");
    }

    // Update hidden inputs
    const idInput = modal.querySelector(".qv-variant-id");
    const qtyInput = modal.querySelector(".qv-quantity");

    if (idInput) {
        idInput.value = radio.value;
    }

    if (qtyInput) {
        qtyInput.value = qty;
    }

    console.log("Updated Variant", idInput?.value);
    console.log("Updated Qty", qtyInput?.value);

    // Close dropdown
    if (dropdown) {
        dropdown.classList.remove("active");

        const content = dropdown.querySelector(".bulk-content");

        if (content) {
            content.style.display = "none";
        }
    }
});